import http from '@util/http';
import { administrative } from '@api/req';

/**
 * 采购
 */
export async function queryPurchaseList(params) {
  return http.get(administrative.GET_PURCHASE_LIST, params);
}

export async function queryPurchaseMyList(params) {
  return http.get(administrative.GET_PURCHASE_MY, params);
}

export async function queryMyPurchaseCheckList(params) {
  return http.get(administrative.GET_PURCHASE_CHECK, params);
}

export async function queryPurchaseOrgStatic(params) {
  return http.get(administrative.GET_PURCHASE_STATIC_ORG, params);
}

export async function queryPurchaseIncubatorStatic(params) {
  return http.get(administrative.GET_PURCHASE_STATIC_INCUBATOR, params);
}

export async function queryPurchaseOrgRecord(params) {
  return http.get(administrative.GET_PURCHASE_RECORD_ORG, params);
}

export async function queryPurchaseInfo(params) {
  return http.get(administrative.GET_PURCHASE_INFO, params);
}

export async function querySavePurchase(params) {
  return http.post(administrative.PURCHASE_SAVE, params);
}

export async function queryDeletePurchase(params) {
  return http.get(administrative.PURCHASE_DELETE, params);
}

export async function queryNextPurchase(params) {
  return http.get(administrative.PURCHASE_NEXT, params);
}

export async function queryTransferPurchase(params) {
  return http.post(administrative.PURCHASE_TRANSFER, params);
}

export async function queryReturnPurchase(params) {
  return http.post(administrative.PURCHASE_RETURN, params);
}

export async function queryCallbackPurchase(params) {
  return http.get(administrative.PURCHASE_CALLBACK, params);
}

export async function queryPurchaseWorkflow(params) {
  return http.get(administrative.PURCHASE_WORKFLOW, params);
}

export async function queryPurchaseWriteInfo(params) {
  return http.get(administrative.GET_PURCHASE_WRITE_INFO, params);
}

export async function querySaveWritePurchase(params) {
  return http.post(administrative.PURCHASE_WRITE_SAVE, params);
}



// WEBPACK FOOTER //
// ./src/api/administrative/purchase.js